module.exports = __webpack_public_path__ + "img/Collins-Aerospace.a08bf822.png";